import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppAgendaContext  } from '../context/AppAgendaContext';
import { useAppAgendaContext } from '../context/AppAgendaContext';
import WizardPaso4 from '../components/WizardPaso4';
import styled from 'styled-components';
import { getHorariosVigente, listaAgendamientosFiltrados } from '../services/api/authService';
import feriadosData from '../services/feriados.json';

const formatearFechaDesdeObjeto = (fecha) => {
  const año = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const dia = String(fecha.getDate()).padStart(2, "0");
  return `${año}-${mes}-${dia}`;
};

const SeleccionaFecHora = () => {
    useEffect(() => {
      setPasoActual("SeleccionaFecHora");
    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "paso_fecha_hora" });
    
      setUltimoEventoGTM("paso_fecha_hora");
    }, []);

    const navigate = useNavigate();
    const {
      contextData,
      setContextData,
      setPasoActual,
      setUltimoEventoGTM,
      sessionId,
      utmData,
      registrarEventoVisual
    } = useContext(AppAgendaContext);

    const [horariosDisponibles, setHorariosDisponibles] = useState([]);
    const [loadingHorarios, setLoadingHorarios] = useState(false);
    const [errorHorarios, setErrorHorarios] = useState(null);
    const [rutsParaConsultar, setRutsParaConsultar] = useState([]);
    const [diasActivos, setDiasActivos] = useState([]);
    const [cacheAgendamientos, setCacheAgendamientos] = useState({}); // Cache temporal
    const [horariosOcupados, setHorariosOcupados] = useState(new Set());
    const [selectedDate, setSelectedDate] = useState(null); 
    const [selectedDay, setSelectedDay] = useState(null);
    const [expandedCards, setExpandedCards] = useState({});
    const [expandedCardRut, setExpandedCardRut] = useState(null);
    const [mensajeAlerta, setMensajeAlerta] = useState("");
    const logEvento = async ({ paso, evento, descripcion, campo, valor }) => {
      const payload = {
        session_id: sessionId,
        paso,
        evento,
        descripcion,
        campo_afectado: campo || null,
        valor_ingresado: valor || null,
        fecha_evento: new Date().toISOString(),
        ...utmData,
        origen_referrer: document.referrer || null
      };

      try {
        await fetch('/api/agendamiento/evento', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      } catch (error) {
        console.error("Error enviando evento:", error);
      }
    };
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [selectedDateTime, setSelectedDateTime] = useState(null);
    const { updateSillonAndTipo } = useAppAgendaContext();
    const [modoInicialExpandido, setModoInicialExpandido] = useState(true);
    
    const firstRender = useRef(true); // 🔵 Controla la primera ejecución
    const token = localStorage.getItem("authToken") || "";

    const feriadosSet = useMemo(() => {
      return new Set(feriadosData.map(f => f.fer_fecha.trim()));
    }, []);


    useEffect(() => {
      if (selectedDay) {
        const nuevaFecha = formatearFechaDesdeObjeto(selectedDay);
        if (nuevaFecha !== selectedDate) {
          setSelectedDate(nuevaFecha);
          setContextData(prev => ({ ...prev, selectedDate: nuevaFecha }));
          /* console.log("🔄 Sincronizando selectedDate desde selectedDay:", nuevaFecha); */
        }
      }
    }, [selectedDay]);

        
    /* Calendario */
    const [startDate, setStartDate] = useState(new Date());
    /*  const [selectedDay, setSelectedDay] = useState(new Date(new Date().setDate(new Date().getDate() + 1))); */
    const [sliderDirection, setSliderDirection] = useState('');
    const DAYS_IN_WEEK = 7;
    const MONTHS_AHEAD_LIMIT = 3;    
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + MONTHS_AHEAD_LIMIT);

    /** Genera un array con los días de la semana a partir de una fecha dada */
    const generateWeekDaysArray = (baseDate) => {
      const weekDays = [];
      const startOfWeek = new Date(baseDate);
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1); // Inicia en lunes
    
      for (let i = 0; i < DAYS_IN_WEEK; i++) {
        const day = new Date(startOfWeek);
        day.setDate(startOfWeek.getDate() + i);
    
        let nombreDia = day.toLocaleDateString('es-ES', { weekday: 'long' });
        nombreDia = nombreDia.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        nombreDia = nombreDia.charAt(0).toUpperCase() + nombreDia.slice(1);
    
        if (nombreDia === "Domingo") continue; // ← OMITIR DOMINGO
    
        weekDays.push({ fecha: day, nombre: nombreDia });
      }
      return weekDays;
    };

    /* Función para avanzar una semana */
    const handleNextWeek = () => {
      const newStartDate = new Date(startDate);
      newStartDate.setDate(newStartDate.getDate() + DAYS_IN_WEEK);

      if (newStartDate <= endDate) {
        setSliderDirection('fade');
        setStartDate(newStartDate);
        setSelectedAppointment(null);
        setSelectedDateTime(null);

        // Generar los días de la nueva semana
        const diasSemana = generateWeekDaysArray(newStartDate);
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // Eliminar horas para comparar solo fechas

        /* console.log("📅 Nueva semana asignada (Next):", newStartDate.toDateString()); */

        // Validar si la fecha seleccionada sigue siendo válida y está en el futuro
        const fechaSigueSiendoValida = diasSemana.some(dia =>
            dia.fecha.toDateString() === selectedDay?.toDateString() &&
            diasActivos.includes(dia.nombre) &&
            dia.fecha >= hoy
        );

        /* console.log("🟢 Fecha sigue siendo válida?", fechaSigueSiendoValida); */

        if (!fechaSigueSiendoValida) {
          const primerDiaDisponible = diasSemana.find(dia =>
              diasActivos.includes(dia.nombre) && dia.fecha >= hoy
          );
      
          if (primerDiaDisponible) {
              const formattedDate = formatearFechaDesdeObjeto(primerDiaDisponible.fecha);
      
              setSelectedDay(primerDiaDisponible.fecha);
              setSelectedDate(formattedDate); // 🔹 Sincronizar `selectedDate`
              setContextData(prev => ({ ...prev, selectedDate: formattedDate })); // 🔹 Sincronizar con `contextData`
              
              /* console.log("✅ Nuevo día seleccionado (Next):", formattedDate); */
              setMensajeAlerta("");
          } else {
              setMensajeAlerta("No hay horarios disponibles en esta semana.");
              setSelectedDay(null);
              setSelectedDate(null); // 🔹 Evitar consultas innecesarias si no hay fechas disponibles
              /* console.log("⚠️ No hay horarios disponibles en esta semana."); */
          }
        }        
      }
    };

    const handlePrevWeek = () => {
      const newStartDate = new Date(startDate);
      newStartDate.setDate(newStartDate.getDate() - DAYS_IN_WEEK); // Retroceder una semana completa
    
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0); // 🔹 Eliminar la hora para comparar solo fechas
    
      const manana = new Date(hoy);
      manana.setDate(hoy.getDate() + 1); // 🔹 Definir "mañana" como la fecha mínima válida
    
      if (newStartDate >= hoy) {
        setSliderDirection('fade');
        setStartDate(newStartDate);
        setSelectedAppointment(null);
        setSelectedDateTime(null);        
    
        // 🔹 Limpiar horarios ocupados antes de cambiar de semana
        setHorariosOcupados(new Set());
    
        // 🔹 Obtener los días de la nueva semana en orden normal
        const diasSemana = generateWeekDaysArray(newStartDate);
    
        /* console.log("📅 Nueva semana asignada (Prev):", newStartDate.toDateString()); */
    
        const fechaSigueSiendoValida = diasSemana.some(dia =>
          dia.fecha.toDateString() === selectedDay?.toDateString() &&
          diasActivos.includes(dia.nombre) &&
          dia.fecha >= manana
        );
    
        /* console.log("🟢 Fecha sigue siendo válida?", fechaSigueSiendoValida); */
    
        let primerDiaDisponible = null;
    
        if (!fechaSigueSiendoValida) {
          primerDiaDisponible = diasSemana.find(dia =>
            diasActivos.includes(dia.nombre) && dia.fecha >= manana
          );
    
          if (primerDiaDisponible) {
            const formattedDate = primerDiaDisponible.fecha.toISOString().split("T")[0];
            setSelectedDay(primerDiaDisponible.fecha);
            setSelectedDate(formattedDate);
            setContextData(prev => ({ ...prev, selectedDate: formattedDate }));
            /* console.log("✅ Nuevo día seleccionado (Prev - Ajustado):", formattedDate); */
            setMensajeAlerta("");
          } else {
            setMensajeAlerta("No hay horarios disponibles en esta semana.");
            setSelectedDay(null);
            setSelectedDate(null);
            /* console.log("⚠️ No hay horarios disponibles en esta semana."); */
          }
        }
    
        // 🔐 SOLO EJECUTAR esto si NO se acaba de seleccionar un primer día disponible arriba
        if (newStartDate.getTime() === hoy.getTime() && !primerDiaDisponible) {
          const manana = new Date(hoy);
          manana.setDate(hoy.getDate() + 1);
          manana.setHours(0, 0, 0, 0);
    
          const formattedFromDay = formatearFechaDesdeObjeto(manana);
    
          const nombreDiaManana = manana.toLocaleDateString('es-ES', { weekday: 'long' })
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
          const nombreDiaCapitalizado = nombreDiaManana.charAt(0).toUpperCase() + nombreDiaManana.slice(1);
    
          const mananaEstaActivo = diasActivos.includes(nombreDiaCapitalizado);
    
          if (mananaEstaActivo) {
            setSelectedDay(manana);
            setSelectedDate(formattedFromDay);
            setContextData(prev => ({ ...prev, selectedDate: formattedFromDay }));
            /* console.log("🔁 Semana actual: Seleccionando mañana correctamente:", formattedFromDay); */
            setMensajeAlerta("");
          } else {
            console.warn("🚫 'Mañana' no es un día activo, no se selecciona.");
          }
        }
      } else {
        /* console.log("🚫 No se puede retroceder más allá de la fecha mínima permitida."); */
      }
    };
    
              
    const handleDayClick = (day, diaTexto) => {
      // 🔒 Si el día ya está seleccionado, no hacer nada
      if (selectedDay?.toDateString() === day.toDateString()) {
        /* console.log("⏸️ Día ya seleccionado, no se actualiza nuevamente:", diaTexto); */
        return;
      }
    
      const formattedDate = formatearFechaDesdeObjeto(day);
    
      setSelectedDay(day);
      setSelectedDate(formattedDate);
      setSelectedAppointment(null);
      setSelectedDateTime(null);
      setContextData(prev => ({ ...prev, selectedDate: formattedDate }));

      registrarEventoVisual({
        paso: 'SeleccionaFecHora',
        evento: 'seleccion_dia',
        descripcion: `Seleccionó día: ${formattedDate}`
      });

      logEvento({
        paso: 'SeleccionaFecHora',
        evento: 'seleccion_dia',
        descripcion: `Usuario seleccionó el día ${formattedDate}`,
        campo: 'fecha',
        valor: formattedDate
      });      
    
      /* console.log("📆 Día seleccionado en el calendario:", diaTexto); */
    };
  
    /** Genera los días de la semana */
    const generateWeekDays = () => {
      const weekDays = [];
      const startOfWeek = new Date(startDate);
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1); // Comienza en lunes
    
      for (let i = 0; i < DAYS_IN_WEEK; i++) {
        const day = new Date(startOfWeek);
        day.setDate(startOfWeek.getDate() + i);
    
        let nombreDia = day.toLocaleDateString('es-ES', { weekday: 'long' });
        nombreDia = nombreDia.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        nombreDia = nombreDia.charAt(0).toUpperCase() + nombreDia.slice(1);
    
        if (nombreDia === "Domingo") continue; // ← OMITIR DOMINGO
    
        /* const estaDisponible = diasActivos.includes(nombreDia); */
    
        const fechaFormateada = formatearFechaDesdeObjeto(day);
        const esFeriado = feriadosSet.has(fechaFormateada);
        const estaDisponible = diasActivos.includes(nombreDia) && !esFeriado;

        weekDays.push(
            <Day
              key={i}
              title={esFeriado ? `Feriado: ${feriadosData.find(f => f.fer_fecha === fechaFormateada)?.fer_festividad || ''}` : ''}
              className={`text-azul 
                ${selectedDay && selectedDay.toDateString() === day.toDateString() ? 'active' : ''} 
                ${day < new Date() ? 'inactive' : ''} 
                ${!estaDisponible ? 'disabled' : ''} 
                ${esFeriado ? 'feriado' : ''}`}
              onClick={() => estaDisponible && handleDayClick(day)}
            >
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px',
              borderRadius: '10px',
              backgroundColor: selectedDay?.toDateString() === day.toDateString() ? '#00AEEF' : 'transparent',
              color: selectedDay?.toDateString() === day.toDateString() ? '#ffffff' : estaDisponible ? '#00547f' : '#CCCCCC',
              boxShadow: selectedDay?.toDateString() === day.toDateString() ? '0 4px 8px rgba(0, 174, 239, 0.4)' : 'none',
              transition: 'all 0.3s ease'
            }}>
              <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {day.getDate().toString().padStart(2, '0')}
              </span>
              <span style={{ fontSize: '14px' }}>
                {day.toLocaleDateString('es-ES', { weekday: 'short' }).replace(/^(.)/, (m) => m.toUpperCase())}
              </span>
            </div>
          </Day>  
        );
      }
      return weekDays;
    };
        
    /** Obtiene el nombre del mes actual */
    const getMonthName = () => {
      const monthNames = [
          "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
          "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      return selectedDay ? monthNames[selectedDay.getMonth()] : monthNames[startDate.getMonth()];
    };

    /** Función para obtener horarios */
    const consultarHorarios = async () => {
      setLoadingHorarios(true);
      setErrorHorarios(null);
  
      try {
          let odontRutParam = null;
  
          // Si estamos en "SeleccionaProfSuc", enviamos el odont_rut en la consulta
          if (contextData.paginaOrigen === 'SeleccionaProfSuc' && rutsParaConsultar.length === 1) {
              odontRutParam = rutsParaConsultar[0];  // Asignar el odont_rut
              /* console.log("🟢 Consultando horarios para odontólogo específico:", odontRutParam); */
          } else {
              /* console.log("🟢 Consultando horarios para todos los odontólogos de la sucursal"); */
          }
  
          // Llamada a la API con o sin odont_rut según corresponda
          const response = await getHorariosVigente(contextData.sucursalId, odontRutParam, token, "Web2", contextData.pacienteEstado);
          /* console.log("🔍 Respuesta completa del endpoint getHorariosVigente:", response); */
  
          if (response?.datos?.length > 0) {
              let filtrados = response.datos;
  
              // Si la consulta fue sin odont_rut, filtramos manualmente en el frontend
              if (!odontRutParam) {
                  filtrados = response.datos.filter(h => rutsParaConsultar.includes(h.odont_rut));
                  /* console.log("✅ Horarios filtrados por RUT en frontend:", filtrados); */
              }

              const procesarHorariosAgrupados = (horarios) => {
                /* console.log("📌 Procesando horarios para agrupar por odontólogo y día:", horarios); */
              
                const horariosAgrupados = {};
              
                horarios.forEach(horario => {
                  const odontRut = horario.odont_rut;
                  const odontNombre = `${horario.odont_apellidos} ${horario.odont_nombres}`.trim();
                  const sillonNombre = horario.sill_nombre;
                  // EXTRAEMOS los valores de sill_id y tipho_id del objeto recibido
                  const sill_id = horario.sill_id;
                  const tipho_id = horario.tipho_id;
              
                  // Detectar qué días están disponibles (donde el valor es "S")
                  const diasDisponibles = Object.keys(horario).filter(dia => 
                    ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"].includes(dia) && horario[dia] === "S"
                  );
              
                  diasDisponibles.forEach(diaSemana => {
                    const key = `${odontRut}-${diaSemana}`;
              
                    if (!horariosAgrupados[key]) {
                      horariosAgrupados[key] = {
                        odontRut,
                        odontNombre,
                        sillonNombre,
                        diaSemana, // Se almacena el día correctamente
                        horarios: [],
                        // Guardamos sill_id y tipho_id en el grupo para usarlos luego
                        sill_id,
                        tipho_id,
                      };
                    }
              
                    horariosAgrupados[key].horarios.push({
                      hor_id: horario.hor_id,
                      inicio: horario.Inicio,
                      termino: horario.Termino,
                      // Propagamos sill_id y tipho_id en cada bloque
                      sill_id,
                      tipho_id,
                    });
                  });
                });
              
                /* console.log("✅ Horarios agrupados correctamente:", Object.values(horariosAgrupados)); */
                return Object.values(horariosAgrupados);
              };
                            
              /*setHorariosDisponibles(filtrados);*/
              setHorariosDisponibles(procesarHorariosAgrupados(filtrados));
          } else {
              console.warn("⚠️ No se encontraron horarios en la respuesta del endpoint.");
              setHorariosDisponibles([]);
          }
      } catch (error) {
          console.error("❌ Error al obtener horarios:", error);
          setErrorHorarios("No se pudo obtener la lista de horarios.");
      } finally {
          setLoadingHorarios(false);
      }
    };
    
    const calculateHoraFin = (horaInicio, minutosASumar) => {
      const [horas, minutos] = horaInicio.split(":").map(Number);
      const nuevaHora = new Date(0, 0, 0, horas, minutos + minutosASumar);
      const hh = String(nuevaHora.getHours()).padStart(2, "0");
      const mm = String(nuevaHora.getMinutes()).padStart(2, "0");
      return `${hh}:${mm}`;
    };
  
    const handleBlockClick = (timeBlock, hor_id, sill_nombre, odont_rut, odont_nombres, odont_apellidos, sill_id, tipho_id) => {
      if (!selectedDay) {
        console.error('No hay día seleccionado');
        return;
      }
    
      if (horariosOcupados.has(`${hor_id}-${timeBlock}`)) {
        console.warn('Horario no disponible:', timeBlock);
        return;
      }
    
      /*const formattedDate = selectedDay.toISOString().split("T")[0];*/

      const año = selectedDay.getFullYear();
      const mes = String(selectedDay.getMonth() + 1).padStart(2, '0');
      const dia = String(selectedDay.getDate()).padStart(2, '0');
      const formattedDate = `${año}-${mes}-${dia}`;      


      const formattedDateTime = `${formattedDate} ${timeBlock}`;
      const doctorName = `${odont_nombres || ''} ${odont_apellidos || ''}`.trim();
    
      /* console.log("Valores recibidos en handleBlockClick:", { timeBlock, hor_id, sill_nombre, odont_rut, sill_id, tipho_id }); */
    
      setSelectedAppointment({ timeBlock, horId: hor_id, sillonNombre: sill_nombre, odontRut: odont_rut });
      setSelectedDateTime(formattedDateTime);

      registrarEventoVisual({
        paso: 'SeleccionaFecHora',
        evento: 'seleccion_hora',
        descripcion: `Seleccionó hora: ${formattedDateTime}`
      });

      logEvento({
        paso: 'SeleccionaFecHora',
        evento: 'seleccion_hora',
        descripcion: `Usuario seleccionó horario ${formattedDateTime}`,
        campo: 'hora',
        valor: timeBlock
      });      
    
      // Actualiza el contexto con los nuevos valores usando la función updateSillonAndTipo
      updateSillonAndTipo(sill_id, tipho_id);
    
      setContextData((prev) => ({
        ...prev,
        selectedDateTime: formattedDateTime,
        sillonNombre: sill_nombre || 'Sin información',
        odontRut: odont_rut,
        doctorName,
        horId: hor_id,
        ageFecha: formattedDate,
        ageHora: timeBlock,
        ageHoraFin: calculateHoraFin(timeBlock, 30),
      }));
    
      /* console.log('Nuevo horario seleccionado:', {
        sillID: sill_id,
        tiphoId: tipho_id,
        horId: hor_id,
        ageHora: timeBlock,
      }); */
    };
    
    const handleSiguienteClick = () => {
      if (!selectedAppointment) {
        console.warn("⚠️ No se ha seleccionado un horario.");
        return;
      }
    
      const { pacRut, pacNombre, pacCorreo } = contextData;
    
      const pacienteEncontrado = pacRut && pacNombre && pacCorreo;
    
      if (pacienteEncontrado) {
        /* console.log("✅ Paciente encontrado, redirigiendo a ConfirmaFonoMail"); */
        navigate('/ConfirmaFonoMail');
      } else {
        /* console.log("🔄 Paciente NO encontrado, redirigiendo a ConfirmaPaciente"); */
        navigate('/ConfirmaPaciente');
      }
    };

    const handleDateChange = (newDate) => {
      const formattedDate = newDate.toISOString().split("T")[0]; // 🔹 Convertir a "YYYY-MM-DD"
  
      setSelectedDate(formattedDate);
      setContextData(prev => ({ ...prev, selectedDate: formattedDate }));
  
      /* console.log("📅 Nueva fecha seleccionada y actualizada en contextData:", formattedDate); */
    };

    /** 🔵 1️⃣ Establecer RUTs solo en la primera ejecución */
    useEffect(() => {
      if (firstRender.current) {
          firstRender.current = false;
          /* console.log("🔍 Primera ejecución, Validando flujo de navegación en SeleccionaFecHora..."); */
          /* console.log("📌 Datos del Contexto:", contextData); */
  
          let ruts = [];
          if (contextData.paginaOrigen === 'SeleccionaEspSuc' && contextData.odontRuts?.length) {
              ruts = contextData.odontRuts;
              /* console.log("✅ Modo Especialidad: Se consultarán horarios para RUTs:", ruts); */
          } else if (contextData.paginaOrigen === 'SeleccionaProfSuc' && contextData.odontologoRut) {
              ruts = [contextData.odontologoRut];
              /* console.log("✅ Modo Profesional: Se consultará horario para RUT:", ruts); */
          } else {
              /* console.warn("⚠️ No se encontraron datos suficientes para consultar horarios."); */
          }
  
          setRutsParaConsultar(ruts);
      }
    }, []);

    useEffect(() => {
      if (selectedDay || diasActivos.length === 0 || horariosDisponibles.length === 0) return;
    
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
    
      for (let i = 1; i <= 14; i++) {
        const posibleFecha = new Date(hoy);
        posibleFecha.setDate(hoy.getDate() + i);
    
        const nombreDia = posibleFecha.toLocaleDateString('es-ES', { weekday: 'long' })
          .normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        const capitalizado = nombreDia.charAt(0).toUpperCase() + nombreDia.slice(1);
        const formateado = formatearFechaDesdeObjeto(posibleFecha);
    
        const esDomingo = capitalizado === "Domingo";
        const esFeriado = feriadosSet.has(formateado);
        const esDiaActivo = diasActivos.includes(capitalizado);
    
        const tieneHorariosEseDia = horariosDisponibles.some(h =>
          h.diaSemana.normalize("NFD").replace(/[\u0300-\u036f]/g, "") === capitalizado
        );
    
        if (!esDomingo && esDiaActivo && !esFeriado && tieneHorariosEseDia) {
          /* console.log("🎯 Día válido inicial encontrado:", formateado); */
          setSelectedDay(posibleFecha);
          setSelectedDate(formateado);
          setStartDate(new Date(posibleFecha)); // ← 🔁 Sincroniza visual del calendario
          setContextData(prev => ({ ...prev, selectedDate: formateado }));
          break;
        }
      }
    }, [selectedDay, diasActivos, horariosDisponibles, feriadosSet]);
  
    /** 🔵 2️⃣ Ejecutar consulta de horarios solo cuando haya datos */
    useEffect(() => {
      if (rutsParaConsultar.length > 0) {
          consultarHorarios();
      }
    }, [rutsParaConsultar]);
  
    useEffect(() => {
      const diasDisponiblesSet = new Set();
    
      horariosDisponibles.forEach(odontologo => {
        if (odontologo.diaSemana) {
          // 🔧 Normalizar nombre del día (quitar tildes y capitalizar)
          let dia = odontologo.diaSemana.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
          dia = dia.charAt(0).toUpperCase() + dia.slice(1);
    
          diasDisponiblesSet.add(dia);
        }
      });
    
      const diasFinal = [...diasDisponiblesSet];
      /* console.log("✅ Días activos actualizados:", diasFinal); */
      setDiasActivos(diasFinal);
    }, [horariosDisponibles]);
  
  /* console.log("📌 Estado final de horariosDisponibles antes del renderizado:", horariosDisponibles); */
  
  const consultarHorariosOcupados = async (reintento = 0) => {
    try {
      if (!contextData.sucursalId || !selectedDate || !token) {
        console.warn("⚠️ No se ejecuta la consulta porque faltan parámetros.", {
          sucursalId: contextData.sucursalId,
          selectedDate,
          token
        });
        return;
      }
  
      const fechaDesde = selectedDate;
      const fechaHasta = selectedDate;
  
      /* console.log("📡 Consultando horarios ocupados para:", {
        sucursalId: contextData.sucursalId,
        odontRuts: rutsParaConsultar,
        fechaDesde,
        fechaHasta,
      }); */
  
      const response = await listaAgendamientosFiltrados(
        token,
        contextData.sucursalId,
        fechaDesde,
        fechaHasta
      );
  
      if (response?.datos?.length > 0) {
        /* console.log("✅ Respuesta del endpoint listaAgendamientosFiltrados:", response.datos); */
  
        const bloques15 = new Set();
  
        // 🔍 Procesar todos los agendamientos sin filtrar por odontologo_rut
        response.datos.forEach(horario => {
          const horaInicio = horario.age_hora.substring(0, 5);
          const horaFin = horario.age_hora_fin.substring(0, 5);
  
          let currentTime = new Date(`2025-02-20T${horaInicio}`);
          const endTime = new Date(`2025-02-20T${horaFin}`);
  
          while (currentTime < endTime) {
            const bloque15 = currentTime.toTimeString().split(" ")[0].substring(0, 5);
            bloques15.add(`${horario.hor_id}-${bloque15}`);
            currentTime.setMinutes(currentTime.getMinutes() + 15);
          }
        });
  
        // Agrupar bloques de 15 en bloques visibles de 30
        const bloques30 = new Set();
  
        bloques15.forEach(bloque => {
          const [horId, horaStr] = bloque.split("-");
          const [hh, mm] = horaStr.split(":").map(Number);
          const minutosAgrupados = Math.floor(mm / 30) * 30;
          const bloque30 = `${horId}-${String(hh).padStart(2, "0")}:${String(minutosAgrupados).padStart(2, "0")}`;
          bloques30.add(bloque30);
        });
  
        setHorariosOcupados(bloques30);
      } else {
        console.warn("⚠️ La respuesta de la API no contiene horarios ocupados.");
        setHorariosOcupados(new Set());
      }
  
    } catch (error) {
      console.error("❌ Error en consultarHorariosOcupados:", error);
  
      if (reintento < 3) {
        console.warn(`🔄 Reintentando consulta (${reintento + 1}/3)...`);
        setTimeout(() => consultarHorariosOcupados(reintento + 1), 2000);
      } else {
        console.error("🚫 No se pudo obtener los horarios ocupados después de 3 intentos.");
      }
    }
  };
  
  useEffect(() => {
    /* console.log("📌 Horarios ocupados actualizados:", horariosOcupados); */
  }, [horariosOcupados]);

  useEffect(() => {
    if (!selectedDate) {
        /* console.warn("⚠️ `selectedDate` aún es null, esperando actualización..."); */
        return;
    }

    /* console.log("🛠️ Verificando parámetros antes de ejecutar `consultarHorariosOcupados`:", {
        sucursalId: contextData.sucursalId,
        selectedDate,
        startDate, // 🔹 Agregado para detectar cambios de semana
        token
    }); */

    if (contextData.sucursalId && selectedDate && token) {
        /* console.log("🔄 Ejecutando consulta de horarios ocupados..."); */
        consultarHorariosOcupados();
    } else {
        console.warn("⚠️ No se puede ejecutar `consultarHorariosOcupados`, faltan parámetros.");
    }
  }, [selectedDate, startDate, rutsParaConsultar]); // 🔹 Agregamos `startDate`

  const obtenerDiasDisponibles = useMemo(() => {
      const diasConDisponibilidad = new Set();

      horariosDisponibles.forEach(odontologo => {
          diasConDisponibilidad.add(odontologo.diaSemana);
      });

      /* console.log("📌 Días con disponibilidad:", diasConDisponibilidad); */
      return diasConDisponibilidad;
  }, [horariosDisponibles]);

  const esDiaDisponible = (nombreDia) => {
    return diasActivos.includes(nombreDia);
  };

  const filtrarHorariosPorDia = useMemo(() => {
    if (!selectedDay || horariosDisponibles.length === 0) return [];

    // 🔹 Convertir el día seleccionado en un formato compatible con la API
    let nombreDia = selectedDay.toLocaleDateString('es-ES', { weekday: 'long' });

    // 🔹 Normalizar acentos y convertir a mayúscula la primera letra
    const normalizarTexto = (texto) => {
        return texto
            .normalize("NFD") // 🔹 Elimina tildes
            .replace(/[\u0300-\u036f]/g, "") // 🔹 Quita caracteres especiales
            .toLowerCase() // 🔹 Convierte a minúsculas
            .replace(/^\w/, c => c.toUpperCase()); // 🔹 Convierte la primera letra en mayúscula
    };

    nombreDia = normalizarTexto(nombreDia);

    /* console.log("📆 Día seleccionado en el calendario:", nombreDia); */
    /* console.log("📋 Horarios Disponibles Antes del Filtrado:", horariosDisponibles); */

    // 🔹 Filtrar odontólogos que coincidan con el día seleccionado
    const filtrados = horariosDisponibles.filter(odontologo => normalizarTexto(odontologo.diaSemana) === nombreDia);

    /* console.log("✅ Odontólogos disponibles para este día:", filtrados); */
    return filtrados;
  }, [selectedDay, horariosDisponibles]);

  const generarBloquesHorario = (inicio, termino, isExpanded) => {
    if (!inicio || !termino) return [];

    let bloques = [];
    let horaActual = new Date(`2025-02-20T${inicio}`);
    let horaFin = new Date(`2025-02-20T${termino}`);

    while (horaActual < horaFin) {
        let horaStr = horaActual.toTimeString().split(" ")[0].substring(0, 5);
        bloques.push(horaStr);
        horaActual.setMinutes(horaActual.getMinutes() + 30);
    }

    // Cambiamos de 18 a 12 horarios (4 filas x 3 columnas)
    return isExpanded ? bloques : bloques.slice(0, 9);
};

/*
  RESPALDO PRODUCCIÓN

  const toggleExpand = (odontRut) => {
    setExpandedCardRut(prevRut => (prevRut === odontRut ? null : odontRut));
  };

*/

  const cardRefs = useRef({}); // Guarda referencias a cada DoctorCard

  const toggleExpand = (odontRut) => {
    setModoInicialExpandido(false);
  
    setExpandedCardRut(prevRut => {
      // 🔵 Aquí no preguntamos por modoInicialExpandido, sino que actuamos como si fuera contraer directo.
      if (prevRut === null || prevRut !== odontRut) {
        // 🔵 Si antes no había expansión o es otro odontólogo, expandir este
        return odontRut;
      } else {
        // 🔵 Si ya estaba expandido este odontólogo, contraerlo
        return null;
      }
    });
  
    setTimeout(() => {
      if (cardRefs.current[odontRut]) {
        cardRefs.current[odontRut].scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200);
  };
  
  
  /* console.log("📌 Estado final de horariosDisponibles antes del renderizado:", horariosDisponibles); */
    
    return (
        <Container>
            <WizardPaso4 />
            <Row>
                <Column>
                    <Title>Reserva de Horas - Evaluación Dental</Title>
                    <Subtitle>
                        {contextData.sucursalNombre && selectedDay
                          ? `Selecciona un horario en ${getMonthName().toUpperCase()} para ${contextData.sucursalNombre}`
                          : "Selecciona una sucursal para continuar"}
                    </Subtitle>
                </Column>
            </Row>

            {/* Calendario */}
            <CalendarWrapper>
                <Calendar className={`calendar-slider ${sliderDirection}`} onAnimationEnd={() => setSliderDirection('')}>
                    <ChevronButton className="left" onClick={handlePrevWeek}>&lt;</ChevronButton>
                    <Days className="days-slider">{generateWeekDays()}</Days>
                    <ChevronButton className="right" onClick={handleNextWeek}>&gt;</ChevronButton>
                </Calendar>
            </CalendarWrapper>

            {/* 🔹 Alerta de falta de disponibilidad en la semana */}
            {mensajeAlerta && (
                <div className="alert alert-warning text-center" role="alert">
                    {mensajeAlerta}
                </div>
            )}            

            {loadingHorarios ? (
                <LoadingMessage>Cargando horarios disponibles...</LoadingMessage>
            ) : errorHorarios ? (
                <ErrorMessage>{errorHorarios}</ErrorMessage>
            ) : (

                <DoctorContainer>
                    {filtrarHorariosPorDia.length > 0 ? (
                      filtrarHorariosPorDia.map((odontologo, index) => {
                        const isExpanded = expandedCardRut === odontologo.odontRut;

                        // 🔵 Asegurar que todos los cards inicien contraídos por defecto
                        const expandirCard = modoInicialExpandido || expandedCardRut === odontologo.odontRut;

                        const tieneMasDe5Horarios = odontologo.horarios.some((horario) => {
                            const bloques = generarBloquesHorario(horario.inicio, horario.termino, true);
                            return bloques.length > 5;
                        });

                        return (
                            <DoctorCard
                                key={`${odontologo.odontRut}-${index}`}
                                $isExpanded={expandirCard}
                                ref={el => (cardRefs.current[odontologo.odontRut] = el)}
                            >
                                <DoctorInfo>
                                    <DoctorImage src={`/images/imgdocs/${odontologo.odontRut}.jpg`} alt="Foto doctor" />
                                    <DoctorText>
                                        <DoctorName>{odontologo.odontNombre}</DoctorName>
                                        <Specialty>Agendamiento Online</Specialty>
                                    </DoctorText>
                                </DoctorInfo>

                                <TimeButtons>
                                    {odontologo.horarios.length > 0 &&
                                        odontologo.horarios.map((horario, idx) => {
                                            const bloques = generarBloquesHorario(horario.inicio, horario.termino, expandirCard);

                                            return bloques.map((bloque, i) => {
                                                const isSelected =
                                                    selectedAppointment?.timeBlock === bloque &&
                                                    selectedAppointment?.horId === horario.hor_id;

                                                const isOccupied = horariosOcupados.has(`${horario.hor_id}-${bloque}`);

                                                return (
                                                    <ButtonHora
                                                        key={`${idx}-${i}`}
                                                        data-horid={horario.hor_id}
                                                        selected={isSelected}
                                                        disabled={isOccupied}
                                                        className={isOccupied ? 'disabled' : ''}
                                                        onClick={() => {
                                                            if (!isOccupied) {
                                                                handleBlockClick(
                                                                    bloque,
                                                                    horario.hor_id,
                                                                    odontologo.sillonNombre,
                                                                    odontologo.odontRut,
                                                                    odontologo.odontNombre.split(" ")[0],
                                                                    odontologo.odontNombre.split(" ").slice(1).join(" "),
                                                                    horario.sill_id,
                                                                    horario.tipho_id
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {bloque}
                                                    </ButtonHora>
                                                );
                                            });
                                        })}
                                </TimeButtons>
                                {tieneMasDe5Horarios && (
                                    <MoreHoursButton onClick={() => toggleExpand(odontologo.odontRut)}>
                                        {expandirCard ? "Ver menos" : "Ver más horas disponibles"}
                                    </MoreHoursButton>
                                )}
                            </DoctorCard>
                        );
                      })


                        
                    ) : (
                        // 🔹 Movemos la alerta aquí, dentro de DoctorContainer, pero fuera de DoctorCard
                        <div className="d-flex justify-content-center mt-3">
                            <div className="alert alert-warning text-center w-50">
                                No hay horarios disponibles para esta selección.
                            </div>
                        </div>
                    )}
                </DoctorContainer>
            )}
            <NavigationButtons>
                <NavButton secondary onClick={() => navigate('/SeleccionaTipoHora')}>
                    Volver
                </NavButton>
                
                <NavButton onClick={handleSiguienteClick} disabled={!selectedAppointment}>
                    Siguiente
                </NavButton>
            </NavigationButtons>
        </Container>
    );
  };

// Styled Components
const Container = styled.div`
  max-width: 800px; /* Define el ancho máximo del cuadro blanco */
  margin: 0 auto; /* Centra el contenedor */
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

const Column = styled.div`
  flex: 1;
  text-align: center;
`;

const Title = styled.h3`
  font-size: 24px;
  color: #00608a;
`;

const Subtitle = styled.h3`
  font-size: 24px;
  color: #00bfc4;
`;

const CalendarIcon = styled.div`
  cursor: pointer;
`;

const CalendarWrapper = styled.div`
  margin: 30px auto;
  text-align: center;
`;

const Calendar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  &.fade {
    animation: fadeEffect 0.5s ease-in-out;
  }

  @keyframes fadeEffect {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const ChevronButton = styled.button`
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  color: #00cfd4;
  border: none;
  background: none;
  transition: all 0.3s ease;
  outline: none;

  &:hover {
    transform: scale(1.1);
    background-color: #f0f0f0;
    border-radius: 50%;
  }
`;

const Days = styled.div`
  display: flex;
  justify-content: space-around;
  width: 80%;
  transition: transform 0.5s ease;
  transform: translateX(0);
`;

const Day = styled.div`
  text-align: center;
  margin: 0 5px;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
  transition: all 0.3s ease;

  &.active {
    color: #fff;
    background-color: #00cfd4;
  }

  &.inactive {
    pointer-events: none;
    color: #aaa;
  }

  &:hover {
    background-color: #8AB1D9;
    color: #336699;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &.disabled {
      opacity: 0.3;
      pointer-events: none;
      color: #aaa;
  }

  &.active {
      background-color: #00AEEF;
      color: white;
      font-weight: bold;
  }

  &.feriado {
    background-color: #f2f2f2;
    border: 1px solid #cccccc;
    color: #999999;
    font-weight: normal;
    pointer-events: none;
    opacity: 0.7;
  }
`;

const Divider = styled.div`
  height: 2px;
  background-color: #e9ecef;
`;

const DoctorContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columnas en PC */
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 100px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr); /* 1 columna en móviles */
  }
`;

const DoctorCard = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: fit-content;
  max-height: ${({ $isExpanded }) => ($isExpanded ? "1000px" : "180px")}; /* Ajuste dinámico */
  opacity: ${({ $isExpanded }) => ($isExpanded ? "1" : "0.8")};
  position: relative;
  margin-bottom: 20px;
`;

const DoctorInfo = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
`;

const DoctorImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
`;

const DoctorText = styled.div`
  text-align: left;
`;

const DoctorName = styled.p`
  font-weight: bold;
  margin: 0;
`;

const Specialty = styled.p`
  color: #6c757d;
  margin: 0;
`;

const TimeButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
    margin-bottom: 15px;
    width: 100%;
    height: auto;
    min-height: fit-content;
    
    & > button {
        flex: 0 0 calc(33.33% - 10px);
        min-width: 70px;
    }
`;

const ButtonHora = styled.button`
    background-color: ${(props) => (props.selected ? '#00547f' : '#fff')};
    border: 2px solid #00547f;
    border-radius: 5px;
    padding: 10px 15px;
    color: ${(props) => (props.selected ? '#fff' : '#00547f')};
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative; /* Para el indicador de selección */

    /* 🔵 Efecto Hover */
    &:hover {
        background-color: ${(props) => (props.selected ? '#00547f' : '#00CFD4')};
        color: #fff;
        transform: translateY(-2px);
    }

    /* 🔵 Feedback visual cuando está seleccionado */
    ${(props) => props.selected && `
        &::after {
            content: '✓';
            position: absolute;
            top: -10px;
            right: -10px;
            background: #00CFD4;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: white;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        transform: scale(1.05);
    `}

    /* 🔴 Estilos para horarios ocupados */
    &.disabled {
        background-color: #e9ecef;
        border-color: #adb5bd;
        color: #adb5bd;
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.6;
    }

    /* 🔵 Efecto al hacer clic */
    &:active {
        transform: ${(props) => (props.selected ? 'scale(1.05)' : 'scale(0.98)')};
    }

    /* 🔵 Efecto visual para selección */
    box-shadow: ${(props) => (props.selected ? '0px 4px 12px rgba(0, 84, 127, 0.3)' : 'none')};
`;


const MoreHoursButton = styled.button`
  background-color: #00cfd4;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
  margin-top: 10px;
  width: 100%;
  text-align: center;
  transition: all 0.3s ease;

  /* 🔥 FORZAMOS SU VISIBILIDAD */
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative !important;
  z-index: 1000 !important;

  &:hover {
    background-color: #008c9e;
  }
`;

const NavigationButtons = styled.div`
  text-align: center;
  position: sticky; /* Cambiado de fixed a sticky */
  bottom: 0; /* Mantén la posición inferior relativa al contenedor */
  width: 100%; /* Asegura que ocupe el ancho del contenedor */
  background-color: #fff; /* Fondo blanco */
  padding: 10px 0; /* Espaciado vertical */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Sombra */
  z-index: 1000; /* Prioridad en la superposición */
`;

const NavButton = styled.button`
  background-color: ${(props) => (props.secondary ? '#fff' : props.disabled ? '#e9ecef' : '#00cfd4')};
  color: ${(props) => (props.secondary ? '#6c757d' : props.disabled ? '#adb5bd' : '#fff')};
  border: ${(props) => (props.secondary ? '1px solid #6c757d' : 'none')};
  border-radius: 20px;
  padding: 10px 20px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  margin: 0 10px;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

const LoadingMessage = styled.p`
    font-size: 18px;
    color: #00608a;
    text-align: center;
    margin-top: 20px;
`;

const ErrorMessage = styled.p`
    font-size: 18px;
    color: red;
    text-align: center;
    margin-top: 20px;
`;



export default SeleccionaFecHora;